import React, { Suspense } from "react";
import { useMerchantContext } from "lib/contexts/MerchantProvider";

const Altcha = React.lazy(() => import("./Altcha"));
const TurnstileWrapper = React.lazy(() => import("./Turnstile"));

export enum CaptchaStatus {
  LOADING = "loading",
  SUCCESS = "success",
  ERROR = "error",
}

export interface CaptchaState {
  token: string | null;
  status: CaptchaStatus;
}

interface CaptchaWrapperProps {
  context: string;
  onTokenChange: (token: CaptchaState) => void;
  status?: CaptchaStatus | string;
}

export const CaptchaWrapper: React.FC<CaptchaWrapperProps> = (props) => {
  const {
    state: { merchant },
  } = useMerchantContext();

  return (
    <div className={props.status === "error" ? "block w-full" : "hidden"}>
      <Suspense fallback={<></>}>
        {merchant?.captchaProvider === "ALTCHA" ? <Altcha {...props} /> : <TurnstileWrapper {...props} />}
      </Suspense>
    </div>
  );
};
